import consts from "@/consts"
import i18n from "@/i18n";
// import {arraySplitIntoChunks} from "@/lib/lib";
import {arrayFilter_OnlyUnique, getApiProps} from "@/lib/lib";

const changedField = 'changed__time';


export default {
    state: {
        screenshots_index: [],
        screenshots: [],
    },
    actions: {
        fetchScreenshots({commit, dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchScreenshots', args, time: Date.now() / 1000})
                dispatch('setLastCall', {name: 'fetchLastScreenshots', args, time: Date.now() / 1000})

                let params = getApiProps('screenshots', {withAddress: 1, ...args})
                delete params.unitId
                this.$api.screenshots.getAll(args.unitId, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeScreenshots', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchScreenshots', args, inprogress: false})
                        dispatch('setLastCall', {name: 'fetchLastScreenshots', args, inprogress: false})
                    });
            })
        },
        // fetchLastScreenshots({commit, dispatch, getters}, args) {
        //     return new Promise((resolve, reject) => {
        //         if (!getters.getApiToken) {
        //             return reject(false)
        //         }
        //         if (args.unitId > 0 && !args.force) {
        //             let index = getters.getScreenshotsIndex.find(i => (i.unitId == args.unitId && i.date == getters.getDateToday))
        //             if (!index) {
        //                 return resolve(true)
        //             }
        //         }
        //
        //         dispatch('setLastCall', {name: 'fetchScreenshotsChanged', args, time: Date.now() / 1000})
        //         dispatch('setLastCall', {name: 'fetchLastScreenshots', args, time: Date.now() / 1000})
        //
        //         let params = getApiProps('screenshots', {withAddress: 1, ...args})
        //         //if(!args.force) params.lastTimes = getters.getLastSuccessfulScreenshotTimeByUnitIds
        //         delete params.unitId;delete params.last;
        //         this.$api.screenshots.getLast(args.unitId, args.last, params)
        //             .then((response) => {
        //                 if (response.status < 400 && !response.data?.error) {
        //                     commit('storeScreenshots', response.data)
        //                     resolve(true)
        //                 } else {
        //                     reject(response)
        //                 }
        //             })
        //             .catch((error) => {
        //                 reject(error)
        //                 console.error(error);
        //             })
        //             .finally(() => {
        //                 dispatch('setLastCall', {name: 'fetchScreenshotsChanged', args, inprogress: false})
        //                 dispatch('setLastCall', {name: 'fetchLastScreenshots', args, inprogress: false})
        //             });
        //     })
        // },
        fetchScreenshots4Date({commit, dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                args = {unitId: '', date: '', ...args}
                if (args.date == 'today' || !args.date) args.date = getters.getDateToday
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !(args.date > '')) {//!args.unitId ||
                    return reject(false)
                }

                if (args.unitId > 0 && !args.force) {
                    let index = getters.getScreenshotsIndex
                        .find(i => (i.unitId == args.unitId && i.date == args.date && i.filter?.channel == args.filter?.channel))
                    if (index) {
                        return resolve(true)
                    }
                }

                dispatch('setLastCall', {name: 'fetchScreenshots4Date', args, time: Date.now() / 1000})
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastScreenshots', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchScreenshotsChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('screenshots', {withAddress: 1, ...args})
                delete params.unitId;delete params.date;
                this.$api.screenshots.get4Date(args.unitId, args.date, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeScreenshots', response.data)
                            if (!params.limit || response.data.length < params.limit) {
                                commit('setScreenshotsIndex', {...args, count: response.data.length})
                                if (!args.unitId && response.data.length) {
                                    response.data
                                        .map(e => e.unit_id)//toDo all units forEach
                                        .filter(arrayFilter_OnlyUnique)
                                        .forEach(unitId => {
                                            commit('setScreenshotsIndex', {...args, unitId, count: 1})
                                        })
                                }
                            }
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchScreenshots4Date', args, inprogress: false})
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastScreenshots', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchScreenshotsChanged', args, inprogress: false})
                        }
                    });
            })
        },
        fetchScreenshots4Period({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.from || !args.to) {//!args.unitId ||
                    return reject(false)
                }

                // if (args.unitId > 0 && !args.force) {
                //     let index = getters.getScreenshotsIndex.find(i => (i.unitId == args.unitId && i.date == args.date))
                //     if (index) {
                //         return resolve(true)
                //     }
                // }

                dispatch('setLastCall', {name: 'fetchScreenshots4Period', args, time: Date.now() / 1000})
                /* getters.getTimeToday+24h and args.from/to intersect*/
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastScreenshots', args, time: Date.now() / 1000})
                }

                let params = getApiProps('screenshots', {withAddress: 1, ...args})
                delete params.unitId;delete params.from;delete params.to;
                this.$api.screenshots.get4Period(args.unitId, args.from, args.to, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeScreenshots', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchScreenshots4Period', args, inprogress: false})
                        /* getters.getTimeToday+24h and args.from/to intersect*/
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastScreenshots', args, inprogress: false})
                        }
                    });
            })
        },
        fetchLastSuccessfulScreenshots({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {//!args.unitId ||
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchLastSuccessfulScreenshots', args, time: Date.now() / 1000})
                /* getters.getTimeToday+24h and args.from/to intersect*/

                let params = getApiProps('screenshots', {limit: 1, withAddress: 1, ...args})
                delete params.unitId;
                this.$api.screenshots.getLastSuccessful(args.unitId, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeScreenshots', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchLastSuccessfulScreenshots', args, inprogress: false})
                    });
            })
        },
        fetchScreenshotsChanged({dispatch, getters}, args) {
            if (!getters.getApiToken) {
                return Promise.resolve(null)
            }

            dispatch('setLastCall', {name: 'fetchLastScreenshots', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchScreenshotsChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            delete args.date
            return dispatch('fetchScreenshots', args)
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchLastScreenshots', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchScreenshotsChanged', args, inprogress: false})
                });
        },

        //groups
        fetchScreenshotsUnitsGroup({commit, dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchScreenshotsUnitsGroup', args, time: Date.now() / 1000})
                dispatch('setLastCall', {name: 'fetchLastScreenshotsUnitsGroup', args, time: Date.now() / 1000})

                let params = getApiProps('screenshots', {withAddress: 1, ...args})
                delete params.groupId
                this.$api.UnitsGroupsScreenshots.getAll(args.groupId, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeScreenshots', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchScreenshotsUnitsGroup', args, inprogress: false})
                        dispatch('setLastCall', {name: 'fetchLastScreenshotsUnitsGroup', args, inprogress: false})
                    });
            })
        },
        // fetchLastScreenshotsUnitsGroup({commit, dispatch, getters}, args) {
        //     return new Promise((resolve, reject) => {
        //         if (!getters.getApiToken) {
        //             return reject(false)
        //         }
        //         if (args.unitId > 0 && !args.force) {
        //             let index = getters.getScreenshotsIndex.find(i => (i.unitId == args.unitId && i.date == getters.getDateToday))
        //             if (!index) {
        //                 return resolve(true)
        //             }
        //         }
        //
        //         dispatch('setLastCall', {name: 'fetchLastScreenshotsUnitsGroup', args, time: Date.now() / 1000})
        //         dispatch('setLastCall', {name: 'fetchScreenshotsUnitsGroupChanged', args, time: Date.now() / 1000})
        //
        //         let params = getApiProps('screenshots', {withAddress: 1, ...args})
        //         //if(!args.force) params.lastTimes = getters.getLastSuccessfulScreenshotTimeByUnitIds
        //         delete params.groupId;delete params.last;
        //         this.$api.UnitsGroupsScreenshots.getLast(args.groupId, args.last, params)
        //             .then((response) => {
        //                 if (response.status < 400 && !response.data?.error) {
        //                     commit('storeScreenshots', response.data)
        //                     resolve(true)
        //                 } else {
        //                     reject(response)
        //                 }
        //             })
        //             .catch((error) => {
        //                 reject(error)
        //                 console.error(error);
        //             })
        //             .finally(() => {
        //                 dispatch('setLastCall', {name: 'fetchLastScreenshotsUnitsGroup', args, inprogress: false})
        //                 dispatch('setLastCall', {name: 'fetchScreenshotsUnitsGroupChanged', args, inprogress: false})
        //             });
        //     })
        // },
        fetchScreenshotsUnitsGroup4Date({commit, dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                args = {groupId: '', date: '', ...args}
                if (args.date == 'today' || !args.date) args.date = getters.getDateToday
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !(args.date > '')) {//!args.unitId ||
                    return reject(false)
                }

                // if (args.groupId > 0) {
                //     let index = getters.getScreenshotsIndex.find(i => (i.groupId == args.groupId && i.date == args.date))
                //     if (index) {
                //         return resolve(true)
                //     }
                // }

                dispatch('setLastCall', {name: 'fetchScreenshotsUnitsGroup4Date', args, time: Date.now() / 1000})
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastScreenshotsUnitsGroup', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchScreenshotsUnitsGroupChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('screenshots', {withAddress: 1, ...args})
                delete params.groupId;delete params.date;
                this.$api.UnitsGroupsScreenshots.get4Date(args.groupId, args.date, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeScreenshots', response.data)
                            if (!params.limit || response.data.length < params.limit) {
                                commit('setScreenshotsIndex', {...args, count: response.data.length})
                                if (!args.groupId && response.data.length) {
                                    response.data
                                        .map(e => e.unit_id)//toDo all units forEach
                                        .filter(arrayFilter_OnlyUnique)
                                        .forEach(unitId => {
                                            commit('setScreenshotsIndex', {...args, unitId, count: 1})
                                        })
                                }
                            }
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchScreenshotsUnitsGroup4Date', args, inprogress: false})
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastScreenshotsUnitsGroup', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchScreenshotsUnitsGroupChanged', args, inprogress: false})
                        }
                    });
            })
        },
        fetchScreenshotsUnitsGroup4Period({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.from || !args.to) {//!args.unitId ||
                    return reject(false)
                }

                // if (args.groupId > 0) {
                //     let screenshot = getters.getScreenshots.find(e => (e.unit_id == args.unitId && e.time?.utc >= args.from && e.time?.utc <= args.to))
                //     if (screenshot) {
                //         return resolve(true)
                //     }
                // }

                dispatch('setLastCall', {name: 'fetchScreenshotsUnitsGroup4Period', args, time: Date.now() / 1000})
                /* getters.getTimeToday+24h and args.from/to intersect*/
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastScreenshotsUnitsGroup', args, time: Date.now() / 1000})
                }

                let params = getApiProps('screenshots', {withAddress: 1, ...args})
                delete params.groupId;delete params.from;delete params.to;
                this.$api.UnitsGroupsScreenshots.get4Period(args.groupId, args.from, args.to, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeScreenshots', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchScreenshotsUnitsGroup4Period', args, inprogress: false})
                        /* getters.getTimeToday+24h and args.from/to intersect*/
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastScreenshotsUnitsGroup', args, inprogress: false})
                        }
                    });
            })
        },
        fetchLastSuccessfulScreenshotsUnitsGroup({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {//!args.unitId ||
                    return reject(false)
                }
                // if (args.groupId > 0) {
                //     let screenshot = getters.getScreenshots.find(e => (e.unit_id == args.unitId && e.time?.utc >= args.from && e.time?.utc <= args.to))
                //     if (screenshot) {
                //         return resolve(true)
                //     }
                // }

                dispatch('setLastCall', {name: 'fetchLastSuccessfulScreenshotsUnitsGroup', args, time: Date.now() / 1000})
                /* getters.getTimeToday+24h and args.from/to intersect*/
                let params = getApiProps('screenshots', {limit: 1, withAddress: 1, ...args})
                delete params.groupId;
                this.$api.UnitsGroupsScreenshots.getLastSuccessful(args.groupId, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeScreenshots', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchLastSuccessfulScreenshotsUnitsGroup', args, inprogress: false})
                    });
            })
        },
        fetchScreenshotsUnitsGroupChanged({dispatch, getters}, args) {
            if (!getters.getApiToken) {
                return Promise.resolve(null)
            }

            dispatch('setLastCall', {name: 'fetchLastScreenshotsUnitsGroup', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchScreenshotsUnitsGroupChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            delete args.date
            return dispatch('fetchScreenshotsUnitsGroup', args)
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchLastScreenshotsUnitsGroup', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchScreenshotsUnitsGroupChanged', args, inprogress: false})
                });
        },

        reloadScreenshots({commit, dispatch}, args) {
            commit('clearScreenshots')
            return dispatch('fetchScreenshots4Date', {date: 'today', ...args})
        },
        clearScreenshotsForUnit({commit}, unitId) {
            commit('clearScreenshots', {unitId})
        },

        //sayHello() {}
    },
    mutations: {
        setScreenshotsIndex(state, params) {
            let i = state.screenshots_index.findIndex(i => i.date == params.date && i.unitId == params.unitId)
            if (i < 0) {
                state.screenshots_index.push(Object.freeze({...params}))
            } else {
                state.screenshots_index[i] = Object.freeze({...state.screenshots_index[i], ...params})
            }
        },
        storeScreenshots(state, nScreenshots) {
            if (!state.screenshots.length) {
                state.screenshots = nScreenshots.map(e => Object.freeze(e))
                return true
            }

            nScreenshots.forEach(function (nScreenshot) {
                let i = state.screenshots.findIndex(s => (s.xid == nScreenshot.xid))
                if (i < 0) {
                    if (!nScreenshot?.removed_at) state.screenshots.push(Object.freeze(nScreenshot))
                } else
                if (state.screenshots[i][changedField] != nScreenshot[changedField]) {
                    //updateObjectByDiff(state.screenshots[i], nScreenshot)
                    if (nScreenshot?.removed_at) {
                        state.screenshots.splice(i, 1)
                    } else {
                        delete nScreenshot.xid
                        state.screenshots[i] = Object.freeze({...state.screenshots[i], ...nScreenshot})
                    }
                }
            })
        },
        clearScreenshots(state, {unitId} = {}) {
            if (unitId) {
                state.screenshots = state.screenshots.filter(s => (s.unit_id || s.object_id) != unitId);
                state.screenshots_index = state.screenshots_index.filter(s => s.unitId != unitId);
            } else {
                state.screenshots = [];
                state.screenshots_index = [];
            }
        },
    },
    getters: {
        getNewScreenshotsCount(state, getters) {
            let lastVisit = getters.getLastVisitNotifications
            if (getters.getTimeToday > lastVisit) lastVisit = getters.getTimeToday
            return state.screenshots.filter(e => e.time?.utc > lastVisit).length
        },
        getScreenshotsIndex(state) {
            return state.screenshots_index
        },
        getScreenshots(state) {
            return state.screenshots
        },
        getSuccessfulScreenshots(state) {
            return state.screenshots.filter(s => s?.files?.length && +(s?.time?.utc || 0) > 0)
        },
        getScreenshotsI18nMessages(state) {
            return state.screenshots
                .map((screenshotsTextByXid, screenshot) => {
                    let message = screenshot?.message?.msg;
                    if (message) {
                        let matches = message.matchAll(/\$t{([\w]+)}/gi);
                        Array.from(matches).forEach(match => {
                            let str = screenshot?.message[match[1]] || ''
                            let translateKey = ['message', screenshot.hw_type, str].join('.')
                            str = i18n.global.te(translateKey) ? i18n.global.t(translateKey) : str
                            message = message.replace(match[0], str);
                        })
                    }
                    return {type: screenshot.type, xid: screenshot.xid, message};
                })
        },
        getScreenshotsI18nMessagesByXid(state) {
            return state.screenshots
                .reduce((screenshotsTextByXid, screenshot) => {
                    let message = screenshot?.message?.msg;
                    if (message) {
                        let matches = message.matchAll(/\$t{([\w]+)}/gi);
                        Array.from(matches).forEach(match => {
                            let str = screenshot?.message[match[1]] || ''
                            let translateKey = ['message', screenshot.hw_type, str].join('.')
                            str = i18n.global.te(translateKey) ? i18n.global.t(translateKey) : str
                            message = message.replace(match[0], str);
                        })
                    }
                    screenshotsTextByXid[screenshot.xid] = message;// || i18n.global.t('message.Unknown')//???
                    return screenshotsTextByXid;
                }, {})
        },
        getLastSuccessfulScreenshotTimeByUnitIds(state) {
            return state.screenshots
                .filter(s => s?.files?.length)
                .reduce((timeByUnitIds, s) => {
                    if (+(s?.time?.utc || 0) > +(timeByUnitIds[s.unit_id] || 0)) {
                        timeByUnitIds[s.unit_id] = s.time.utc
                    }
                    return timeByUnitIds
                }, {})
        },
        getLastSuccessfulScreenshotByUnitIds(state) {
            return state.screenshots
                .filter(s => s?.files?.length)
                .reduce((screenshots, s) => {
                    if (+(s?.time?.utc || 0) > +(screenshots[s.unit_id]?.time?.utc || 0)) {
                        screenshots[s.unit_id] = s
                    }
                    return screenshots
                }, {})
        },
    }
}
